import React from 'react'
import { useFilterContext } from '../context/filter_context'
import GridView from './GridView'
import ListView from './ListView'

const ProdutosList = () => {
  const { filtered_produtos: produtos, grid_view } = useFilterContext()
  if (produtos.length < 1) {
    return (
      <h5 style={{ textTransform: 'none' }}>
        Desculpe, nenhum produto correspondeu à sua pesquisa ...
      </h5>
    )
  }
  if (grid_view === false) {
    return <ListView produtos={produtos} />
  }
  return <GridView produtos={produtos}>Lista de produtos</GridView>
}

export default ProdutosList
